import { getPlaceholder } from '@helpers/placeholder';
import SvgChevron from '@img/icons/chevron-down.svg';
import React from 'react';
import S from '../../UmbracoForm.styles';
const DropDownList = React.forwardRef(({ id, field, dirty, error, ...otherProps }, ref) => {
    const isMultiple = field.settings?.allowMultipleSelections === 'True'
        ? {
            multiple: true,
        }
        : null;
    return (React.createElement(S.Field, { className: error?.message && 'invalid', "data-dirty": dirty, "data-invalid": !!error, "data-dropdownlist": true },
        React.createElement(S.Label, { htmlFor: id ?? field.alias },
            field.caption,
            field.required ? '*' : null),
        React.createElement(S.SelectHolder, null,
            React.createElement(S.Select, { ref: ref, id: id ?? field.alias, placeholder: getPlaceholder(field), autoComplete: field.settings?.autocompleteAttribute ? field.settings.autocompleteAttribute : undefined, ...isMultiple, required: field.required, ...otherProps },
                React.createElement("option", { value: "", disabled: true, selected: true, hidden: true }, getPlaceholder(field)),
                field.preValues?.map((option, index) => (React.createElement("option", { key: `option-${index}`, value: option.value }, option.caption)))),
            React.createElement(S.Arrow, null,
                React.createElement(SvgChevron, null))),
        field.helpText && React.createElement(S.HelpText, null, field.helpText),
        error && React.createElement(S.Error, null, error.message)));
});
DropDownList.displayName = 'DropDownList';
export default DropDownList;
